<template>
  <div class="video-catalog-wrap">
    <div class="video-type">
      <span :class="{ active: videoType === 0 }" @click="changeType(0)"
        >录播+直播</span
      >
      <span :class="{ active: videoType === 1 }" @click="changeType(1)"
        >录播</span
      >
      <span :class="{ active: videoType === 2 }" @click="changeType(2)"
        >直播</span
      >
    </div>
    <happy-scroll color="rgba(42,85,218,0.8)" resize hide-horizontal>
      <ul class="video-fav-list">
        <template v-if="videoType !== 2">
          <li
            v-for="(item, index) in pptList"
            :key="index"
            :class="{ active: pptId == item.PptId }"
          >
            <div class="title-img" @click="changeVideo(item)">
              <a><img :src="item.PicFileName2" :alt="item.PptName" /></a>
              <div class="title-lock" v-show="!item.isTryLook">
                <Icon type="ios-lock" size="26" />
              </div>
            </div>
            <div class="right-side">
              <div
                class="video-title"
                :title="item.PptName"
                @click="changeVideo(item)"
              >
                <template v-if="item.isTryLook">
                  <a> {{ item.PptName }}</a>
                </template>
                <template v-else>{{ item.PptName }}</template>
              </div>
              <div class="video-attr" v-show="page == 'study' && isBuy">
                视频：已看 {{ item.playTimes || 0 }} 次
              </div>
            </div>
          </li>
        </template>
        <template v-if="videoType !== 1">
          <li
            v-for="live in liveList"
            :key="live.id"
            :class="{ 'course-study-live': isCourseStudy }"
          >
            <div
              v-if="!isCourseStudy"
              class="title-img"
              @click="changeLive(live)"
            >
              <a>
                <img
                  v-if="!live.roomId"
                  src="../../assets/images/livebg.png"
                  :alt="live.title"
                />
                <img
                  v-else
                  :src="concatImageUrl(live.roomId)"
                  :alt="live.title"
                />
              </a>
              <div class="title-lock" v-show="!live.isLook || !live.isTryLook">
                <Icon type="ios-lock" size="26" />
              </div>
            </div>

            <div class="right-side">
              <div
                class="video-title"
                :title="live.title"
                @click="changeLive(live)"
              >
                <template v-if="live.isLook">
                  <a> {{ live.title }}</a>
                </template>
                <template v-else>{{ live.title }}</template>
              </div>
              <div class="video-attr" v-show="page == 'study' && isBuy">
                <span v-if="live.liveStatus === 0">[还未开始]</span>
                <span
                  v-else-if="
                    live.liveStatus === 1 &&
                    (live.liveType === 1 || live.liveType === 2)
                  "
                  >[正在直播]</span
                >
                <span
                  v-else-if="live.liveStatus === 2 && live.playbackStatus === 4"
                  >[观看回放]</span
                >
                <span v-else>[生成中]</span> &nbsp;
                <span>{{ dateFormat(live.startDate, "MM-dd hh:mm") }}</span>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </happy-scroll>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { dateFormat } from "../../utils/utils";
import { HappyScroll } from "vue-happy-scroll";
import { study } from "../../request";
import "vue-happy-scroll/docs/happy-scroll.css";
export default {
  mixins: [siteMixin],
  props: {
    page: {
      type: String,
      default: "default",
    },
    isCourseStudy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      videoType: 0,
      pptList: [],
      liveList: [],
      dateFormat,
    };
  },
  watch: {
    reviewCatalog() {
      this.firstLoaded = false;
      this.initPlayList();
    },
  },
  beforeDestroy() {
    this.setReviewCatalog([]);
    this.setPlayList([]);
  },
  mounted() {
    this.initPlayList();
  },
  methods: {
    initPlayList() {
      this.pptList = this.reviewCatalog.filter((m) => m.type === 1) || [];
      this.liveList = this.reviewCatalog.filter((m) => m.type === 2) || [];
      if (this.pptList.length > 0) {
        //console.log("ssss", this.reviewCatalog);
        let list = [];
        this.reviewCatalog.forEach((one) => {
          if (one.isTryLook == 1 && one.bVideoId) {
            list.push({
              pptId: one.PptId,
              videoId: one.bVideoId,
              catId: 0,
            });
          }
        });
        this.setPlayList(list);
      }
    },
    changeVideo(item) {
      if (!item.isTryLook) return;
      if (item.liveStatus === 2 && !item.replayId) return;
      this.setVideoId(item.bVideoId);
      this.setPptId(item.PptId);
      this.setReviewPositionName(item.PptName);
      this.$emit("change", "vod");
    },
    changeLive(item) {
      if (!item.isLook || !item.isTryLook) return;
      study
        .saveLiveTime(this.loginUser.userId, undefined, item.id)
        .then((res) => {});
      window.open(`/live/index/${item.id}?v=1`, "_blank");
      // if (item.videoId) {
      //   this.setVideoId(item.videoId);
      //   this.setPptId(0);
      //   this.setReviewPositionName(item.title);
      //   this.$emit('change', 'live');
      // } else {
      //   study
      //     .saveLiveTime(this.loginUser.userId, item.channelId, item.id)
      //     .then((res) => {});
      //   window.open(`/live/index/${item.id}?v=1`, '_blank');
      // }
    },
    changeType(value) {
      this.videoType = value;
    },
  },
  components: {
    HappyScroll,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.video-catalog-wrap {
  width: 336px;
  height: 470px;
  .course-study-live {
    height: auto;
    min-height: 75px;
    .right-side {
      width: 100%;
      height: auto;
      padding-left: 0;
      float: none;
      .video-title {
        display: -webkit-box;
        height: auto;
        max-height: 50px;
        line-height: 25px;
        white-space: normal;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
}
.video-type {
  display: flex;
  background-color: #1b1b1b;
  margin-top: -12px;
  // border-top: 1px solid #000;
  span {
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    padding: 4px 12px;
    cursor: pointer;
    & + span {
      border-left: 1px solid #272727;
    }
    &.active,
    &:hover {
      background-color: #313131;
    }
  }
}
.video-fav-list {
  width: 336px;
  padding-bottom: 20px;
}
.video-fav-list li.active {
  background: #313131;
}
.video-fav-list li {
  font-size: 1.4rem;
  height: 75px;
  /* border-bottom: 1px solid #494949; */
  padding: 10px;
  overflow: hidden;
}
.video-fav-list li .title-img {
  position: relative;
  width: 96px;
  height: 54px;
  overflow: hidden;
  float: left;
  .title-lock {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 54px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.7);
  }
}
.video-fav-list li .title-img img {
  width: 100%;
  height: auto;
}
.video-fav-list li .right-side {
  width: 160px;
  padding-left: 10px;
  height: 54px;
  float: left;
  overflow: hidden;
}
// .video-fav-list li.active .right-side .video-title {
//   color: #999;
// }
.video-fav-list li .right-side .video-title {
  height: 28px;
  line-height: 25px;
  color: #fff;
  .ellipsis();
  a {
    color: #fff;
  }
}
.video-fav-list li .right-side .video-attr {
  line-height: 24px;
  height: 24px;
  overflow: hidden;
  color: #969696;
}
</style>
